// extracted by mini-css-extract-plugin
export default {"header":"ReceiptPageHeader_header__CFQ1D","button__back":"ReceiptPageHeader_button__back__1DpqM","text":"ReceiptPageHeader_text__9bXV4"};